export type UniformEnvironment = 'preview' | 'staging' | 'production';

export type UniformRegenerationMetadata = {
	id: string | undefined;
	name: string | undefined;
	modified: string | undefined;
	generationTime: number | undefined;
	trace: string | undefined;
};

export const isUniformEnvironment = (env: string): env is UniformEnvironment => {
	return ['preview', 'staging', 'production'].includes(env);
};

export const getUniformEnvironment = (urlSearch: string): UniformEnvironment => {
	let uniformEnvironment = process.env['CLIENT_LIBRARY_ENV'] ?? '';

	// Handle empty or invalid URL search params (e.g., during SSR)
	let searchParams: URLSearchParams;
	try {
		searchParams = new URLSearchParams(new URL(urlSearch).search);
	} catch {
		searchParams = new URLSearchParams();
	}

	if (searchParams.get('wacae-preview') && uniformEnvironment !== 'production') {
		return 'preview';
	}

	if (uniformEnvironment === 'local') {
		return 'staging';
	}

	if (!isUniformEnvironment(uniformEnvironment)) {
		uniformEnvironment = 'preview';
	}

	return uniformEnvironment as UniformEnvironment;
};
